module.exports = __webpack_public_path__ + "static/media/facebook-icon.1f10bd12.svg";